import React, {Component} from 'react';
import {MemoryRouter as Router, Route, Switch, NavLink, withRouter, Redirect, Link} from 'react-router-dom';
import {connect} from 'react-redux';
import useToggle from 'UseToggle.js';
import {bindActionCreators} from 'redux';
import AccountSessionTimer from 'AccountSessionTimer.js';
import AccountMenu from 'AccountMenu.js';
import S from 'StyledAccount.js';
import {translation, formatMoney, redirect} from 'utilsHelper.js';
import _find from 'lodash/find';
import _each from 'lodash/each';
import _size from 'lodash/size';
import _isEmpty from 'lodash/isEmpty';
import {fetchFreebetByStatus} from 'freebetActions.js';
import {loadVeryficationStatus} from 'accountActions.js';
import {logOutUser} from 'authActions.js';
import UploadUserAvatar from 'UploadUserAvatar.js';
import CmsPage from 'CmsPage.js';
import ModalOpacity from 'ModalOpacity.js';
import { getCustomerPromotions,updateCustomerPromotion } from 'customerActions.js';

class Account extends Component {

    static getDerivedStateFromError = (error) => {
        return {hasError: true};
    };

    state = {hasError: false, freebetCount: 0, freebetBalance: 0.0,showVipModal: false,showInfoStatusModal:false};
  

    componentDidMount = async() => {
        
        const {fetchFreebetByStatus, loadVeryficationStatus, accountTab,getCustomerPromotions} = this.props;
        await getCustomerPromotions(true, true)
        if (!this.props.user) {
            redirect('/');
            return; 
        } else if (accountTab){
            this.props.history.push('/konto/'+accountTab);
        }

        try {

            loadVeryficationStatus();
            const config = {
                status: 'ACTIVE'
            };
            const {active} = await fetchFreebetByStatus(config);
          
            let freebetBalance = 0;
            if (_size(active) > 0){
                freebetBalance = active[0].freebetStake;
            }
            this.setState((prevState) => {
                return {...prevState, freebetCount: _size(active), freebetBalance };
            })

        } catch (error) {
            console.log('fetchFreebetByStatus:' + error);
        }
    };

    getBalanceList = () => {
        
        const {user:{bonusBalanceList, currencyCode, balance}} = this.props;
        const options = [];
        const mainBalance = {
            value: 0,
            label: `${translation('account_balance')}: ${formatMoney(balance)} ${currencyCode}`
        };

        options.push(mainBalance);

        _each(bonusBalanceList, ({nameKey, currency, wagerBonusId, amount}) => {
            const bonusBalance = {
                value: wagerBonusId,
                label: `${translation(nameKey)}: ${formatMoney(amount)} ${currency}`
            };
            options.push(bonusBalance);
        });

        return options;
    };

    getBonusBalanceSingleAmount = () => {
        const {user:{bonusBalanceList, currencyCode}} = this.props;

        let bonusAmount = `0.00 ${translation('common_pln')}`;
        if (bonusBalanceList && bonusBalanceList.length > 0){
            const amount = formatMoney(bonusBalanceList[0].amount); 
            bonusAmount = `${amount} ${bonusBalanceList[0].currency}`;
        }

        return bonusAmount;
    };

    selectedOption = () => {
        const currentBalanceId = localStorage.getItem('_bonus_balance_id') || this.props.balanceId;
        const selectedValue = _find(this.getBalanceList(), {value: Number(currentBalanceId)});
        return selectedValue;
    };

    onBalanceChange = ({value}) => {
        const balanceId = value;
        const setBonusBalance = Boolean(balanceId);

        this.props.toggleBalance(setBonusBalance, balanceId);
        localStorage.setItem('_bonus_balance_id', balanceId);
    };

    onUserDataLinkClick = (event, href) => {
        event.preventDefault();
        redirect(href);
    };
    handleModalView = (isModalShown)=>{
        const {getCustomerPromotions} = this.props;
        if(!isModalShown){
            this.toggleModal('showVipModal');
        }else{
           getCustomerPromotions(true).then(res=>{
            this.toggleModal('showVipModal');
            this.toggleModal('showInfoStatusModal')
           }).catch(err=>{
            this.toggleModal('showVipModal');
            this.toggleModal('showInfoStatusModal')

           })
            
        }
    };

    handleCloseVipModal = () => {
        const {getCustomerPromotions} = this.props;
        getCustomerPromotions(false).then(res=>{
                this.toggleModal('showVipModal');
                this.toggleModal('showInfoStatusModal')
            }).catch(err=>{
                this.toggleModal('showVipModal');
                this.toggleModal('showInfoStatusModal')
            })
    };

    toggleModal = (type) => {
        this.setState((prevState) => {
            return {...prevState, [type]: !prevState[type]}
        });
    };

    render() {
        if (!this.props.user) {
            return null;
        }
        const {user: {balance, currencyCode, firstName, lastName, groups}, constensPromotion, accountData, shouldVipCTABeNotDisplayed, logOutUser} = this.props;
        const {hasError, showVipModal, showInfoStatusModal} = this.state;
        const isVipModalVisible = typeof groups !== 'undefined' && groups["VIP_MARKETING"]?.status =="NOT_SET" && !shouldVipCTABeNotDisplayed;
        return (
            <S.AccountWrapper className="account-wrapper">
                      {isVipModalVisible && (
                                <S.VipCtaBanner isModal={false}>
                                    <CmsPage name="vip-marketing-cta" isPlaces={true} />
                                    <S.VipCtaButton  onClick={()=>this.handleModalView(showVipModal)}>Dołącz!</S.VipCtaButton>
                                </S.VipCtaBanner>
                            )}
                <ModalOpacity isOpen={showVipModal}
                            toggleOpen={this.toggleModal.bind(this, 'showVipModal')}
                            showHeader={false}
                            showHeaderIcon={false}
                            showHeaderTitle={false}
                            showCloseIcon={false}
                            padding="0px"
                            width="350px"
                            preventCloseOnOverlay={true}>
                                <S.VipCtaBanner isModal={true}>
                                    <CmsPage name="vip-marketing-modal-not-set" isPlaces={true} />
                                    <S.VipCtaButtonsContainer>
                                        <S.VipCtaButton className='extra-margin' data-translation={'account_vipmarketing_accept'} onClick={()=>this.handleModalView(showVipModal)}>{translation('account_vipmarketing_accept')}</S.VipCtaButton>
                                        <S.VipCtaButton className='extra-margin' data-translation={'account_vipmarketing_reject_btn'} onClick={()=>this.handleCloseVipModal()}>{translation('account_vipmarketing_reject_btn')}</S.VipCtaButton>
                                    </S.VipCtaButtonsContainer>
                                </S.VipCtaBanner>
                </ModalOpacity>
                <ModalOpacity 
                    isOpen={showInfoStatusModal} 
                    showCloseIcon={true} 
                    showHeader={false}
                    showHeaderIcon={false}
                    showHeaderTitle={false}
                    padding="0px"
                    toggleOpen={this.toggleModal.bind(this,"showInfoStatusModal")}>
                        <S.VipCtaBanner isModal={true}>
                            <CmsPage name={constensPromotion?.length > 0 ? `vip-marketing-modal-success`:`vip-marketing-modal-failure`} isPlaces={true} />
                            <S.VipCtaButtonsContainer>
                                <S.VipCtaButton  onClick={this.toggleModal.bind(this,"showInfoStatusModal")}>{translation('account_vipmarketing_close')}</S.VipCtaButton>
                            </S.VipCtaButtonsContainer>
                        </S.VipCtaBanner>
                </ModalOpacity>
                    <S.AccountTopPanel className="account-top-panel">
                  
                        <S.UserDataContainer>    

                            <S.UserAvatarContainer className="user-avatar-container">
                                <S.UserAvatar className="user-avatar">
                                    <UploadUserAvatar></UploadUserAvatar>
                                </S.UserAvatar>
                            </S.UserAvatarContainer>


                            <S.UserNameDataContainer className="user-name-data-container">
                                <S.UserName className="user-name">{firstName} {lastName}</S.UserName>
                                <S.UserDataButtonContainer  onClick={(e) => { this.onUserDataLinkClick(e, '/konto/edycja'); }}>
                                    <S.UserDataButton className="user-data-button">
                                            {translation('account_userPanel_userData')}
                                    </S.UserDataButton>
                                </S.UserDataButtonContainer>
                                
                            </S.UserNameDataContainer>

                        </S.UserDataContainer>

                        <S.Separator/>

                        <S.UserBalanceContainer className="user-balance-container">

                            <S.UserMainBalance>
                                <S.UserMainBalanceLabel>{translation('account_userPanel_balance')}</S.UserMainBalanceLabel>
                                <S.UserMainBalanceContainer className="user-main-balance-container">
                                    <S.UserMainBalanceValue>{ formatMoney(balance) }</S.UserMainBalanceValue>
                                    <S.UserMainBalanceCurrency>{translation('common_pln')}</S.UserMainBalanceCurrency>
                                </S.UserMainBalanceContainer>
                            </S.UserMainBalance>

                            <S.UserBonusBalanceWrapper>
                                <S.UserBonusBalance>
                                    <S.UserBonusBalanceLabel>{translation('account_userPanel_bonus')}</S.UserBonusBalanceLabel>
                                    <S.UserBonusBalanceAmount className="user-bonus-balance-amount">{ this.getBonusBalanceSingleAmount() }</S.UserBonusBalanceAmount>
                                </S.UserBonusBalance>
                            </S.UserBonusBalanceWrapper>

                            <S.UserFreebets className="user-freebets">
                                <S.FreebetLabel>{translation('account_userPanel_freebetCount')}</S.FreebetLabel>
                                <S.FreebetsBalanceValue>{formatMoney(this.state.freebetBalance)} {translation('common_pln')}</S.FreebetsBalanceValue>

                            </S.UserFreebets>

                        </S.UserBalanceContainer>
                        

                    </S.AccountTopPanel>

                    <S.AccountMainMenuContainer className="account-main-menu-container">

                        <AccountMenu logOut={logOutUser}/>
                            
                    </S.AccountMainMenuContainer>

                    <S.UserDataSessionTimerContainer className="user-data-session-timer-container">
                        <S.AccountSessionTimerWrapper>
                            <S.AccountSessionLabel>{translation('account_userSessionTime')}</S.AccountSessionLabel>
                            <AccountSessionTimer/>
                        </S.AccountSessionTimerWrapper>
                        <S.UserActivityLink as={NavLink} to='/konto/historia-sesji' onClick={(e) => this.onUserDataLinkClick(e, '/konto/historia-sesji') } className="user-activity-link">{translation('account_userPanel_activity')}
                        </S.UserActivityLink>
                    </S.UserDataSessionTimerContainer>

            </S.AccountWrapper>
        );
    }
}

const mapStateToProps = (state, props) => {
    const {Account:{ accountData}, Auth: {user},Customer:{constensPromotion,shouldVipCTABeNotDisplayed }} = state;
    return {
        accountData,
        user,
        constensPromotion,
        shouldVipCTABeNotDisplayed
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        fetchFreebetByStatus: bindActionCreators(fetchFreebetByStatus, dispatch),
        loadVeryficationStatus: bindActionCreators(loadVeryficationStatus, dispatch),
        logOutUser: bindActionCreators(logOutUser, dispatch),
        getCustomerPromotions:bindActionCreators(getCustomerPromotions,dispatch),
        updateCustomerPromotion:bindActionCreators(updateCustomerPromotion,dispatch),
        dispatch
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Account));
